import { useFlags } from 'launchdarkly-react-client-sdk';
import { MaggieFeatureFlags } from '../../../util/feature-flags';
import { useEntityManagementEnabled } from './useEntityManagementEnabled';

/**
 * Beneficial Ownership is put away for the first release. Without deal documents there is
 * no legal beneficial owner to show, and the ledger-derived look-through that stands in
 * for one reads as a blank panel. It is hidden rather than explained.
 *
 * The route, the nav entry and the entity record's cross-link all read this, so turning
 * the flag on for a tenant brings the whole surface back. No local override on purpose,
 * unlike the module flag: hidden has to be what a local build shows too.
 */
export function useBeneficialOwnershipEnabled(): boolean {
  const { showBeneficialOwnership } = useFlags<MaggieFeatureFlags>();
  const isModuleEnabled = useEntityManagementEnabled();

  return isModuleEnabled && Boolean(showBeneficialOwnership);
}
